<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-images</v-icon>
        <span class="title ml-2">Galería de imagenes</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="showAdd = true">Agregar</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="item in fotos" :key="item.id" cols="12" sm="6" md="4">
            <v-card>
              <v-img :src="item.foto">
                <v-row align="end" class="lightbox white--text pa-2 fill-height">
                  <v-col>
                    <div class="body-1">{{ item.descripcion }}</div>
                  </v-col>
                </v-row>
              </v-img>
              <v-card-actions>
                <v-btn color="error" @click="deleteFoto(item.id)">
                  <v-icon left>fas fa-trash</v-icon>
                  Borrar
                </v-btn>
                <v-spacer />
                <v-btn color="secondary" @click="displayEdit(item.id)">
                  <v-icon left>fas fa-edit</v-icon>
                  Editar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-pagination v-model="page" :length="pages"></v-pagination>
      </v-card-text>
    </v-card>
    <!-- =================================================================== -->
    <!-- Dialogs -->
    <!-- =================================================================== -->
    <v-dialog v-model="showAdd" max-width="600px">
      <AddFoto
        @close="showAdd = false"
        @saved="refresh"
      ></AddFoto>
    </v-dialog>
    <v-dialog v-model="showEdit" max-width="500px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon>fas fa-images</v-icon>
          <span class="title ml-2">Editar imagen</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="selected.descripcion"
            label="Descripción"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error">
            <v-icon left>fas fa-times</v-icon>
            Cerrar
          </v-btn>
          <v-spacer />
          <v-btn color="primary" @click="updateFoto()">
            <v-icon left>fas fa-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import AddFoto from '../components/AddFoto'
import { host } from '../config'
export default {
  data () {
    return {
      fotos: [],
      page: 1,
      pages: 1,
      showAdd: false,
      showEdit: false,
      selected: {
        descripcion: ''
      }
    }
  },
  components: {
    AddFoto
  },
  async created () {
    await this.getPages()
    await this.getFotos()
  },
  methods: {
    async getPages () {
      const { data } = await this.$http.fotos.get('/count')
      this.pages = Math.ceil(data / 25)
    },
    async getFotos () {
      const skip = (this.page - 1) * 25
      const { data } = await this.$http.fotos.get(`?_limit=25&_start=${skip}&_sort=createdAt:DESC`)
      this.fotos = data.map(i => {
        return {
          ...i,
          foto: `${host}${i.imagen.url}`
        }
      })
      this.getPages()
    },
    async deleteFoto (id) {
      if (window.confirm('¿Estas seguro de eliminar la foto?')) {
        await this.$http.fotos.delete(`/${id}`)
        this.getFotos()
      }
    },
    displayEdit (id) {
      this.selected = this.fotos.find(i => i.id === id)
      this.showEdit = true
    },
    async refresh () {
      this.showAdd = false
      await this.getPages()
      await this.getFotos()
    },
    async updateFoto () {
      await this.$http.fotos.put(`/${this.selected.id}`, { descripcion: this.selected.descripcion })
      this.getFotos()
      this.showEdit = false
    }
  },
  watch: {
    page () {
      this.getFotos()
    }
  }
}
</script>
